module.exports = __webpack_public_path__ + "static/media/spectaclecouverture.2d091b5c.JPG";